module.exports = __webpack_public_path__ + "assets/202509252035/img/pluvet.ee0ec6d8.jpg";